import React, {useContext} from "react";
import {StyledEngineProvider, ThemeProvider} from "@mui/material/styles";
import "./App.css";
import LanguageProvider from "../context/LanguageContext";
import moment from "moment";
import "moment/locale/hu";
import {ConfirmProvider} from "material-ui-confirm";
import {CompanyEnvironmentContext} from "../context/CompanyEnvironmentContext";

moment.locale("hu");

export const AppProviders = (props) => {
  const companyEnvironmentContext = useContext(CompanyEnvironmentContext);

  return (
    <LanguageProvider>
      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={companyEnvironmentContext.theme}>
          <ConfirmProvider>
            {props.children}
          </ConfirmProvider>
        </ThemeProvider>
      </StyledEngineProvider>
    </LanguageProvider>
  );
};

export default AppProviders;